<div class="change-nugget-preview create-collection" (click)="open($event)">
  <span class="circle-actions" i18n-ngbTooltip ngbTooltip="Add to My Collection" container="body">
    <i class="fa-regular fa-bookmark"></i>
  </span>
</div>